
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/producenter",
      function () {
        return require("private-next-pages/producenter/index.route.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/producenter"])
      });
    }
  